var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20.9534L20 33.3334L7.49999 20.9534C6.6755 20.1511 6.02606 19.1867 5.59257 18.1211C5.15908 17.0555 4.95093 15.9116 4.98122 14.7616C5.01152 13.6116 5.2796 12.4803 5.76859 11.4389C6.25758 10.3976 6.95689 9.46881 7.82247 8.71102C8.68806 7.95323 9.70117 7.38287 10.798 7.03585C11.8949 6.68884 13.0517 6.57269 14.1956 6.69472C15.3395 6.81675 16.4458 7.17431 17.4448 7.74489C18.4437 8.31548 19.3137 9.08672 20 10.01C20.6892 9.09342 21.5602 8.32892 22.5585 7.76439C23.5568 7.19986 24.6608 6.84747 25.8015 6.72925C26.9423 6.61103 28.0951 6.72955 29.1879 7.07737C30.2808 7.42519 31.29 7.99484 32.1526 8.75066C33.0151 9.50647 33.7124 10.4322 34.2007 11.4699C34.689 12.5076 34.9579 13.6349 34.9905 14.7812C35.0231 15.9276 34.8188 17.0684 34.3902 18.1321C33.9617 19.1959 33.3182 20.1598 32.5 20.9634",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10L14.5117 15.4883C14.1992 15.8009 14.0237 16.2247 14.0237 16.6667C14.0237 17.1086 14.1992 17.5325 14.5117 17.845L15.4167 18.75C16.5667 19.9 18.4333 19.9 19.5833 18.75L21.25 17.0833C22.2446 16.0888 23.5935 15.53 25 15.53C26.4065 15.53 27.7554 16.0888 28.75 17.0833L32.5 20.8333M20.8333 25.8333L24.1667 29.1667M25 21.6667L28.3333 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.58bab115c48053a0741510edcb5f583c.svg";
export { ForwardRef as ReactComponent };